import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client/core'
import fetch from 'whatwg-fetch'
import csrf from '@/utils/csrf'

// HTTP connection to the API
const url = window.location
const httpLink = createHttpLink({
  // You should use an absolute URL here
  uri: `${url.protocol}//${url.host}/graphql`,
  headers: {
    [csrf.headerKey]: csrf.token
  },
  fetch: fetch
})

// Cache implementation
const cache = new InMemoryCache()

// Create the apollo client
export const apolloClient = new ApolloClient({
  link: httpLink,
  cache
})
